<app-page-header [pageTitle]="'Stock de Embriones Frescos'" />


<app-filters-container
  [hasData]="frescos.length > 0"
  [hasActiveFilters]="hasActiveFilters"
  [loading]="loading"
  (clearFilters)="clearFilters()"
>
  @if (!auth.clienteDelUsuario()) {
    <app-filter-select
      label="Cliente"
      [options]="clientesOptions"
      [value]="clienteId"
      (valueChange)="onClienteChange($event)"
    />
  }

  <app-filter-select
    label="Disponibilidad"
    [options]="disponibilidadOptions"
    [value]="soloDisponibles"
    (valueChange)="onDisponibilidadChange($event)"
  />
</app-filters-container>

<app-data-table
  [columns]="columns"
  [data]="frescos"
  [loading]="loading"
  [clickableRows]="false"
>
  <ng-template appTableCell="cliente" let-item>
    {{ item.cliente || '-' }}
    @if (item.establecimiento) {
      <br><span class="text-xs text-gray-500 dark:text-gray-400">{{ item.establecimiento }}</span>
    }
  </ng-template>

  <ng-template appTableCell="donante" let-item>
    {{ etiquetaVaca(item.donante) }}
    @if (item.donante?.hbp && rpVaca(item.donante)) {
      <br><span class="text-xs text-gray-500 dark:text-gray-400">HBP: {{ item.donante.hbp }}</span>
    }
  </ng-template>

  <ng-template appTableCell="toro" let-item>
    {{ item.toro?.nombre || '-' }}
    @if (item.toro?.hbp) {
      <br><span class="text-xs text-gray-500 dark:text-gray-400">HBP: {{ item.toro.hbp }}</span>
    }
  </ng-template>

  <!-- El fresco es solo un número: sin técnica ni detalle (2026-10-12)
  <ng-template appTableCell="tecnica" let-item>
    {{ item.tecnica_fiv || '-' }}
  </ng-template>
  -->

  <ng-template appTableCell="fecha_salida" let-item>
    {{ item.fecha_salida | date:'dd/MM/yyyy' }}
    <!-- @if (item.fecha_opu) {
      <br><span class="text-xs text-gray-500 dark:text-gray-400">OPU: {{ item.fecha_opu | date:'dd/MM/yyyy' }}</span>
    } -->
  </ng-template>

  <ng-template appTableCell="fecha_transferencia" let-item>
    @for (te of item.transferencias; track $index) {
      <div>{{ te.fecha | date:'dd/MM/yyyy' }}</div>
    } @empty { - }
  </ng-template>

  <ng-template appTableCell="transferido_a" let-item>
    @for (te of item.transferencias; track $index) {
      <div>{{ te.establecimiento || '-' }}</div>
    } @empty { - }
  </ng-template>

  <ng-template appTableCell="embriones" let-item>
    {{ item.embriones_disponibles }} disp.
    <br><span class="text-xs text-gray-500 dark:text-gray-400">
      {{ item.nro_embriones }} totales · {{ item.embriones_reservados }} asignados
    </span>
  </ng-template>

  <!--
  <ng-template appTableCell="acciones" let-item>
    <div class="flex items-center gap-x-2.5">
      <button
        [attr.aria-label]="'Ver cultivo de origen'"
        (click)="verCultivoOrigen(item)"
        [matTooltip]="'Ver cultivo de origen'"
      >
        <mat-icon class="dark:text-gray-400!">visibility</mat-icon>
      </button>
    </div>
  </ng-template>
  -->
</app-data-table>
